/**
 * ClientCalendarProvider - Combined Context Provider
 * Simplified provider for client portal (view-only)
 */

import React from 'react';
import { ClientCalendarUIProvider } from './ClientCalendarUIContext';

/**
 * Combined Client Calendar Provider
 * Provides calendar state and UI contexts to child components
 * Order matters: State -> UI
 */
export const ClientCalendarProvider = ({ children, ...props }) => {
  return <ClientCalendarUIProvider>{children}</ClientCalendarUIProvider>;
};

export default ClientCalendarProvider;
